import { useEffect, useState } from "react";
import { Col, Form, Select } from "antd";
import { GET_STYLE_LIST_ENDPOINT } from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
import { isArrayAndHasValue } from "../../../utils/functions";

const { Option } = Select;

const NewTodoStyleFilter = () => {
  const [styleList, setStyleList] = useState([]);

  useEffect(() => {
    getStyleList();
  }, []);

  const getStyleList = async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 20,
      ...filterValues,
    };
    const response = await getData(GET_STYLE_LIST_ENDPOINT, false, bodyData);

    if (response && response?.data?.code === 200) {
      setStyleList(response?.data?.data?.data || []);
    }
  };

  return (
    <Col span={6}>
      <Form.Item label="Style" name="style_id">
        <Select
          showSearch
          placeholder="Select a Style"
          onSearch={(value) => {
            getStyleList({ style_no: value });
          }}
          optionFilterProp="children"
          size="small"
          allowClear
          onClear={() => getStyleList()}
        >
          {isArrayAndHasValue(styleList) &&
            styleList.map((item) => (
              <Option value={item.id} key={item.id}>
                {item.style_no}
              </Option>
            ))}
        </Select>
      </Form.Item>
    </Col>
  );
};

export default NewTodoStyleFilter;
